import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  getNoAuthCallParams,
  makeCall,
} from "../../../../utils/service";

export async function RegisterEmployee(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.REGISTEREMPLOYEE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPerosnalDetails(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEERECORDBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePersonalDetail(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(
      urls.UPDATEEMPLOYEEPERSONALDETAIL,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateOfficailInfo(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(
      urls.UPDATEEMPLOYEEOFFICIALDETAIL,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getOfficeDetails(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEEOFFICEDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getBankDetails(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEEBANKDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateLeaveInfo(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEEMPLOYEELEAVEINFO, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateBankInfo(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEEMPLOYEEBANKINFO, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getLeaveDetail(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEELEAVEDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function saveOfficialInfo(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDUSEROFFICE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function saveBankDetails(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.SAVEEMPLOYEEBANKINFO, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function saveLeaveDetails(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.SAVEEMPLOYEEBANKDETAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getSalaryDetail(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEESALARYDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateSalaryInfo(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEEMPLOYEESALARYINFO, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function saveSalaryDetails(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.SAVEEMPLOYEESALARYDETAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

////////////////////////////////////////////////////////////////////////////////////////
export async function getDeveloper() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLDEVELOPER,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getProject(id?: String) {
  try {
    const callParams = await getCallParams("GET");
    if(id && id != ''){
      const response = await makeCall(
        urls.GETPROJECTBYID + id,
        callParams
      );
      return response;
    }else{
      const response = await makeCall(
        urls.GETALLPROJECT,
        callParams
      );
      return response;
    }
  } catch (error) {
    throw error;
  }
}

export async function getPropetyFor() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLPROPERTYFOR,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPropetyType() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLPROPERTYTYPE,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPropetyUnitType(id?: String) {
  try {
    const callParams = await getCallParams("GET");
    if(id && id != ''){
      const response = await makeCall(
        urls.GETPROPERTYUNITTYPEBYID + id,
        callParams
      );
      return response;
    }else{
      const response = await makeCall(
        urls.GETALLPROPERTYUNITTYPE,
        callParams
      );
      return response;
    }
  } catch (error) {
    throw error;
  }
}

export async function getPropetyStatus(id?: String) {
  try {
    const callParams = await getCallParams("GET");
    if(id && id != ''){
      const response = await makeCall(
        urls.GETPROPERTYSTATUSBYID + id,
        callParams
      );
      return response;
    }else{
      const response = await makeCall(
        urls.GETALLPROPERTYSTATUS,
        callParams
      );
      return response;
    }
  } catch (error) {
    throw error;
  }
}

export async function addDeveloper(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDDEVELOPER, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addProject(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDPROJECT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateProjectDetail(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATELEADDEFORMTAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addProjectDetail(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDPROJECTDETAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getProjectDetails(userId?: String) {
  try {
    const callParams = await getCallParams("GET");
    if(userId && userId != ''){
      const response = await makeCall(
        urls.GETPROJECTLISTBYID + userId,
        callParams
      );
      return response;
    }else{
      const response = await makeCall(
        urls.GETPROJECTLIST,
        callParams
      );
      return response;
    }
  } catch (error) {
    throw error;
  }
}

export async function uploadImage(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.UPLOADIMAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getDeveloperTree(id?: String) {
  try {
    const callParams = await getCallParams("GET");
    if(id && id != ''){
      const response = await makeCall(
        urls.GETDEVELOPERTREEBYID + id,
        callParams
      );
      return response;
    }else{
      const response = await makeCall(
        urls.GETDEVELOPERTREE,
        callParams
      );
      return response;
    }
  } catch (error) {
    throw error;
  }
}

export async function addPropetyStatus(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GETAddPROPERTYSTATUS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePropetyStatus(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.GETUPDATEPROPERTYSTATUS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addPropetyUnitType(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GETADDPROPERTYUNITTYPE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePropetyUnitType(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.GETUPDATEPROPERTYUNITTYPE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addPropetyType(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GETADDPROPERTYTYPE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePropetyType(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.GETUPDATEPROPERTYTYPE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addPropetyFor(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GETADDPROPERTYFOR, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePropetyFor(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.GETUPDATEPROPERTYFOR, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}


export async function addForm(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDFORM, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}